var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPrimary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 16,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 14.0009C12.7804 14.0009 15.1627 11.7971 16.1633 10.717C16.4724 10.3834 16.4724 9.88507 16.1633 9.55148C15.1627 8.4714 12.7804 6.26758 10.0007 6.26758C7.22091 6.26758 4.83863 8.4714 3.838 9.55148C3.52895 9.88506 3.52895 10.3834 3.838 10.717C4.83863 11.7971 7.22091 14.0009 10.0007 14.0009Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 11.7457C10.4427 11.7457 10.8666 11.5759 11.1792 11.2738C11.4917 10.9716 11.6673 10.5618 11.6673 10.1345C11.6673 9.70726 11.4917 9.29746 11.1792 8.99532C10.8666 8.69318 10.4427 8.52344 10.0007 8.52344C9.55862 8.52344 9.1347 8.69318 8.82214 8.99532C8.50958 9.29746 8.33398 9.70726 8.33398 10.1345C8.33398 10.5618 8.50958 10.9716 8.82214 11.2738C9.1347 11.5759 9.55862 11.7457 10.0007 11.7457Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3.40039C2 2.84811 2.44772 2.40039 3 2.40039H17C17.5523 2.40039 18 2.84811 18 3.40039V16.8671C18 17.4193 17.5523 17.8671 17 17.8671H3C2.44772 17.8671 2 17.4193 2 16.8671V3.40039Z",
    fill: "#177BF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPrimary);
export default __webpack_public_path__ + "static/media/view_primary.1a9ce36a5fb7efaa99948ea48be16b4a.svg";
export { ForwardRef as ReactComponent };